import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Col,
  Form,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import SupportTickets from "models/supportticket.modal";
import { Link } from "react-router-dom";
import classModal from "models/class.modal";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "components/loader/Loader";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { toast } from "lib/helper";

const SupportTicket = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [dataList, setdataList] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  //const location = useLocation();
  //const searchParams = new URLSearchParams(location.search);
  //const parameters = {};
  //for (let [key, value] of searchParams) {
  // parameters[key] = value;
  //}

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const list = async () => {
    setIsLoading(true);

    // Use static data from model
    const dummyData = {
      data: SupportTickets.staticData,
      meta: {
        current_page: 1,
        per_page: 20,
        total_page: 1,
        total: SupportTickets.staticData.length,
      },
    };

    setTimeout(() => {
      setdataList(dummyData);
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    list();
  }, []);
  const [modal1, setModal1] = useState(false);
  const toggleModal1 = () => {
    setDetail("");
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);
  const toggleModal2 = () => {
    setModal2(!modal2);
  };
  const [id, setId] = useState();
  const MarkStatus = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);

    // Simulate status update
    setTimeout(() => {
      setdataList((prevData) => ({
        ...prevData,
        data: prevData.data.map((ticket) =>
          ticket.id === id
            ? {
                ...ticket,
                status: form.get("status") || ticket.status,
                priority: form.get("priority") || ticket.priority,
                updated_at: new Date().toISOString(),
              }
            : ticket
        ),
      }));
      toast("Ticket status updated successfully", "success");
      toggleModal2();
    }, 500);
  };
  const [detail, setDetail] = useState();
  const getData = async (value) => {
    // Get detail from static data
    const ticket = SupportTickets.staticData.find(
      (ticket) => ticket.id === value
    );
    if (ticket) {
      setDetail({ data: ticket });
    }
  };
  const EditTicket = async () => {};
  const [priority, setPriority] = useState("");

  // Update priority when detail changes
  useEffect(() => {
    if (detail?.data?.priority) {
      setPriority(detail.data.priority);
    } else {
      setPriority(""); // Set to empty string if blank or null
    }
  }, [detail]);

  // Handle priority change
  const handlePriorityChange = (e) => {
    setPriority(e.target.value);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = dataList?.data?.filter((item) => {
    const parent = item?.parent_id?.toLowerCase() || "";
    const subject = item?.subject?.toLowerCase() || "";
    const priority = item?.priority?.toLowerCase() || "";
    const status = String(item?.status || "").toLowerCase();

    return (
      parent.includes(searchTerm.toLowerCase()) ||
      subject.includes(searchTerm.toLowerCase()) ||
      priority.includes(searchTerm.toLowerCase()) ||
      status.includes(searchTerm.toLowerCase())
    );
  });
  return (
    <>
      <div className="pt-7 px-4 overflow-x-hidden">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 ">
                <div className=" d-flex justify-content-between ">
                  <h3 className="mb-0">All Support Tickets</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
                      className="mr-4"
                      type="text"
                      placeholder="Search"
                      size="sm"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)} // Update search term on input change
                    />
                    <Button
                      size="sm"
                      to="/admin/supportticket/addticket/"
                      tag={Link}
                      color="primary"
                      style={{
                        width: "60%",
                        backgroundColor: "#080278",
                        color: "white",
                        border: "none",
                      }}
                    >
                      +Add Ticket
                    </Button>
                  </div>
                </div>
                <div className="d-flex mt-2">
                  <div className="d-flex">
                    <Label for="exampleEmail">Status</Label>
                    <Input
                      className="ml-2 mr-4"
                      type="select"
                      size="sm"
                      style={{ width: "200px" }}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="New">New</option>
                      <option value="Working">Working</option>
                      <option value="Resolved">Resolved</option>
                    </Input>
                  </div>
                  <div className="d-flex">
                    <Label for="exampleEmail">Priority</Label>
                    <Input
                      className="ml-2"
                      type="select"
                      placeholder="Search"
                      size="sm"
                      style={{ width: "200px" }}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                    </Input>
                  </div>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S. No</th>
                    <th scope="col">Raised By</th>
                    <th scope="col">Subject</th>
                    <th scope="col">Priority</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {isLoading ? (
                    <tr>
                      <td
                        colSpan={12}
                        className="text-center align-middle w-full"
                      >
                        Please wait...
                        <Loader />
                      </td>
                    </tr>
                  ) : filteredData.length > 0 ? (
                    filteredData?.map((item, index) => {
                      return (
                        <tr key={item._id} style={{ cursor: "pointer" }}>
                          <td style={{ padding: "0.3rem" }}>
                            {(currentPage - 1) * perPage + index + 1}
                          </td>
                          <td style={{ padding: "0.3rem" }}>
                            {item?.parent_id || "-"}
                          </td>
                          <td style={{ padding: "0.3rem" }}>
                            {item?.subject || "-"}
                          </td>
                          <td style={{ padding: "0.3rem" }}>
                            {item?.priority || "-"}
                          </td>
                          <td style={{ padding: "0.3rem" }}>
                            {item?.status || "-"}
                          </td>
                          <td style={{ padding: "0.3rem" }}>
                            {/* Edit and Delete buttons */}
                            <Link
                              style={{
                                fontSize: "15px",
                                color: "blue",
                                alignItems: "center",
                                display: "inline-block",
                                borderRadius: "30%",
                              }}
                              id={`eyeTooltip-${index}`}
                              onClick={() => {
                                getData(item?.id);
                                toggleModal1();
                              }}
                            >
                              <i className="fa-solid fa-pen-to-square"></i>
                            </Link>

                            <UncontrolledTooltip
                              placement="top"
                              target={`eyeTooltip-${index}`}
                            >
                              View
                            </UncontrolledTooltip>
                            {item?.status !== "Resolved" && (
                              <>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "green",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    borderRadius: "20%",
                                  }}
                                  onClick={() => {
                                    toggleModal2();
                                    setId(item?.id);
                                  }}
                                  id={`userTooltip-${index}`}
                                >
                                  <i className="fa-solid fa-marker"></i>
                                </p>

                                <UncontrolledTooltip
                                  placement="top"
                                  target={`userTooltip-${index}`}
                                >
                                  Mark Status
                                </UncontrolledTooltip>
                              </>
                            )}
                            {item?.status == "Resolved" && (
                              <>
                                <p
                                  style={{
                                    margin: "0 8px",
                                    fontSize: "15px",
                                    color: "green",
                                    cursor: "pointer",
                                    display: "inline-block",
                                    borderRadius: "20%",
                                  }}
                                  id={`userTooltip-${index}`}
                                >
                                  <i class="fa-solid fa-check"></i>
                                </p>

                                <UncontrolledTooltip
                                  placement="top"
                                  target={`userTooltip-${index}`}
                                >
                                  Resolved
                                </UncontrolledTooltip>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="12"
                        style={{ textAlign: "center", padding: "1rem" }}
                      >
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
              {/*   <CardFooter className="py-4">
                   <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/supportticket"
                  /> 
                </CardFooter>*/}
            </Card>
          </div>
        </Row>

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
        <Modal isOpen={modal1} toggle={toggleModal1} size="lg">
          <ModalHeader toggle={toggleModal1}>
            <h4> View Ticket </h4>
          </ModalHeader>
          <ModalBody>
            <div>
              <Form onSubmit={EditTicket}>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}> Subject :-</Label>{" "}
                      {detail?.data?.subject}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        {" "}
                        Contact no :-
                      </Label>{" "}
                      {detail?.data?.parent_id}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>Message :-</Label>
                      <p> {detail?.data?.complaint}</p>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        {" "}
                        Upload ScreenShot(1) :-
                      </Label>
                      <a
                        href={detail?.data?.image1?.link}
                        target="_blank"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            detail?.data?.image1?.link,
                            "_blank",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <img
                          src={detail?.data?.image1?.link}
                          style={{
                            height: "80px",
                            width: "80px",
                            borderRadius: "50%",
                            border: "2px solid gray",
                            cursor: "pointer",
                          }}
                        />
                      </a>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        {" "}
                        Upload ScreenShot(2) :-
                      </Label>
                      <a
                        href={detail?.data?.image2?.link}
                        target="_blank"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            detail?.data?.image2?.link,
                            "_blank",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <img
                          src={detail?.data?.image2?.link}
                          style={{
                            height: "80px",
                            width: "80px",
                            borderRadius: "50%",
                            border: "2px solid gray",
                            cursor: "pointer",
                          }}
                        />
                      </a>
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        {" "}
                        Upload ScreenShot(3) :-
                      </Label>
                      <a
                        href={detail?.data?.image3?.link}
                        target="_blank"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            detail?.data?.image3?.link,
                            "_blank",
                            "width=800,height=600"
                          );
                        }}
                      >
                        <img
                          src={detail?.data?.image3?.link}
                          style={{
                            height: "80px",
                            width: "80px",
                            borderRadius: "50%",
                            border: "2px solid gray",
                            cursor: "pointer",
                          }}
                        />
                      </a>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        Support Type :-
                      </Label>
                      {detail?.data?.support_type}
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>
                        Support Related to :-
                      </Label>
                      {detail?.data?.support_related_to}
                    </FormGroup>
                  </Col>

                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>Status :-</Label>
                      {detail?.data?.status}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={4}>
                    <FormGroup style={{ display: "flex" }}>
                      <Label style={{ fontWeight: "bold" }}>Remark :-</Label>
                      {detail?.data?.remark}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>Priority :-</Label>{" "}
                      {detail?.data?.priority}
                    </FormGroup>
                  </Col>
                </Row>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Button
                    color="secondary"
                    onClick={() => {
                      toggleModal1();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal2} toggle={toggleModal2} size="sm">
          <ModalHeader toggle={toggleModal2}>
            <h4> Mark status </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={MarkStatus}>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Status </Label>
                    <Input name="status" type="select">
                      <option value="New">New</option>
                      <option value="Working">Working</option>
                      <option value="Resolved">Resolved</option>
                    </Input>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup>
                    <Label>Remark </Label>
                    <Input
                      name="remark"
                      type="textarea"
                      placeholder="Enter your remark"
                    ></Input>
                  </FormGroup>
                </Col>
              </Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  color="secondary"
                  onClick={() => {
                    toggleModal2();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                    border: "none",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default SupportTicket;
